import LoadingErrorPanel from '@/components/common/LoadingErrorPanel';
import LoadingMessage from '@/components/common/LoadingMessage';
import type { WebAPIError } from '@/store/api/WebApiResponse';
import type { SerializedError } from '@reduxjs/toolkit/react';
import type { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  status: 'loading' | 'success' | { error: WebAPIError | SerializedError };
}>;

export const ResultsWrap = ({ status, children }: Props) => {
  if (status === 'loading') {
    return <LoadingMessage id="searchInProgress" />;
  }
  if (status === 'success') {
    return children;
  }
  return <LoadingErrorPanel error={status.error} />;
};
